import { render, staticRenderFns } from "./RequiredBadge.vue?vue&type=template&id=5f75e94a&scoped=true"
import script from "./RequiredBadge.vue?vue&type=script&lang=ts"
export * from "./RequiredBadge.vue?vue&type=script&lang=ts"
import style0 from "./RequiredBadge.vue?vue&type=style&index=0&id=5f75e94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75e94a",
  null
  
)

export default component.exports